import React, { createContext, useContext, useEffect, useState } from 'react';

// Theme for the storefront — three choices, cycled by the ThemeToggle:
//
//   light  → normal white storefront
//   dark   → dark blue-black surfaces (`dark:` Tailwind variants)
//   black  → **pure black / AMOLED** (dark + the `theme-black` class, see
//            index.css), which is what phone users ask for
//
// `dark` and `black` both put the `dark` class on <html>, so every existing
// `dark:` utility keeps working; `black` only overrides the surfaces to #000.
const ThemeContext = createContext(null);

const ORDER = ['light', 'dark', 'black'];

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    if (typeof localStorage === 'undefined') return 'light';
    const saved = localStorage.getItem('ms_theme');
    return ORDER.includes(saved) ? saved : 'light';
  });

  const isDark = theme === 'dark' || theme === 'black';

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    document.documentElement.classList.toggle('theme-black', theme === 'black');
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
    localStorage.setItem('ms_theme', theme);
  }, [theme, isDark]);

  /** Light → Dark → Black → Light (the navbar button). */
  const toggle = () => setThemeState((t) => ORDER[(ORDER.indexOf(t) + 1) % ORDER.length]);

  /** Pick one explicitly (the account menu lists all three). */
  const setTheme = (value) => setThemeState(ORDER.includes(value) ? value : 'light');

  return (
    <ThemeContext.Provider value={{ theme, isDark, isBlack: theme === 'black', toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

